import { adminAPIService } from './index'

const route = 'cpc-campaigns'

export default {
  list() {
    return adminAPIService({
      url: route,
      method: 'get',
    })
  },
  create(payload) {
    const body = `json=${encodeURIComponent(JSON.stringify(payload))}`
    return adminAPIService({
      url: route,
      method: 'post',
      data: body,
    })
  },
  listOptions() {
    return adminAPIService({
      url: `${route}/options`,
      method: 'get',
    })
  },
}
